import { render, staticRenderFns } from "./ServicereceiptCreate.vue?vue&type=template&id=6a2dd7c3&scoped=true"
import script from "./ServicereceiptCreate.vue?vue&type=script&lang=js"
export * from "./ServicereceiptCreate.vue?vue&type=script&lang=js"
import style0 from "./ServicereceiptCreate.vue?vue&type=style&index=0&id=6a2dd7c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2dd7c3",
  null
  
)

export default component.exports